import axios from 'axios'
// import { socketService } from '../../../services/socket'

const apiUrl = `https://api.careerroshi.com`
// const apiUrl = `https://chat.careerroshi.com`

// const apiUrl = `http://localhost:4000`

export const adminLoginAction = async (body) => {
    try {
        let url = await axios.post(`${apiUrl}/org/login`, body)
        console.log("url:-=-=-=", url)
        return { success: true, ...url.data }
    } catch (error) {
        console.log(error)
        throw error;
        return { success: false }
    }
}


export const FetchOrganizationUsersList = async (organization, page, limit, search, sort, filter = '') => {
    let result = await axios.get(`${apiUrl}/organizations/alluserlist`, { params: { page, limit, search, sort, filter, organization } })
    // result.data.users = result.data.users.filter(ele => !ele.isAdminOrg )
    return result
}

export const FetchOrganizationDbStats = async (organization) => {
    let result = await axios.get(`${apiUrl}/organizations/stats`, { params: { organization } })
    return result.data
}

export const FetchOrgDetails = async (orgId) => {
    let result = await axios.get(`${apiUrl}/organizations/get/${orgId}`)
    return result.data
}